<template>
  <div class="totals">
    <div class="totals__panel">
      <div class="totals__panel__status">
        <div class="totals__panel__status__name">Interesados</div>
        <div class="totals__panel__status__number totals__panel__status__number--black">{{ alreadyUsers.interested }}</div>
      </div>

      <div class="totals__panel__status">
        <div class="totals__panel__status__name">No aplica</div>
        <div class="totals__panel__status__number totals__panel__status__number--grey">{{ alreadyUsers['non-applicable'] }}</div>
      </div>

      <div class="totals__panel__status">
        <div class="totals__panel__status__name">En estudio de crédito</div>
        <div class="totals__panel__status__number totals__panel__status__number--orange">{{ alreadyUsers['in-study'] }}</div>
      </div>

      <div class="totals__panel__status">
        <div class="totals__panel__status__name">Créditos rechazados</div>
        <div class="totals__panel__status__number totals__panel__status__number--red">{{ alreadyUsers.rejected }}</div>
      </div>

      <div class="totals__panel__status">
        <div class="totals__panel__status__name">Créditos aprobados</div>
        <div class="totals__panel__status__number totals__panel__status__number--green1">{{ alreadyUsers.approved }}</div>
      </div>

      <div class="totals__panel__status">
        <div class="totals__panel__status__name">Desembolsos</div>
        <div class="totals__panel__status__number totals__panel__status__number--green2">{{ alreadyUsers.payed }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Totals',
  computed: {
    alreadyUsers () {
      const alreadyUsers = this.$store.getters.leads.users.already

      const totals = {
        interested: 0,
        'non-applicable': 0,
        'in-study': 0,
        rejected: 0,
        approved: 0,
        payed: 0
      }

      for (const user of alreadyUsers) {
        totals[user.status]++
      }

      return totals
    }
  }
}
</script>

<style>
.totals {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
  width: 100%;
}

.totals__button::before {
  content: "+ ";
}

.totals__button:hover {
  background: rgba(0,83,94,0.93);
}

.totals__panel {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 4px;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 20px 0;
  width: 100%;
}

.totals__panel__status__name {
  color: #999999;
  font-size: 12px;
  font-weight: 500;

  padding-bottom: 10px;
}

.totals__panel__status__number {
  font-size: 20px;
}

.totals__panel__status__number-black {
  color: #000000;
}

.totals__panel__status__number--grey {
  color: #cdcdcd;
}

.totals__panel__status__number--orange {
  color: #f99d37;
}

.totals__panel__status__number--red {
  color: #ea7057;
}

.totals__panel__status__number--green1 {
  color: #1ebaa8;
}

.totals__panel__status__number--green2 {
  color: #bfcd32;
}
</style>
